import { render, staticRenderFns } from "./CaseChangelog.vue?vue&type=template&id=52ccbdb0&scoped=true"
import script from "./CaseChangelog.vue?vue&type=script&lang=js"
export * from "./CaseChangelog.vue?vue&type=script&lang=js"
import style0 from "./CaseChangelog.vue?vue&type=style&index=0&id=52ccbdb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ccbdb0",
  null
  
)

export default component.exports